import React from 'react';

import { Fts } from '../../../app-components';

const FtsSearch = (props) => {
  return <Fts {...props} />;
};

export default FtsSearch;
